import type { GlobalFilter } from './types';

export const GLOBAL_FILTER_KEY = 'global-filter-key';

export const GLOBAL_FILTER_DEFAULT_VALUES = {
  global_realestates: [],
  global_segments: [],
  filter_external_clients: [],
  global_companies: [],
} as const satisfies GlobalFilter[string];

export const QUERYABLE_FILTER_KEYS: ReadonlySet<keyof GlobalFilter[string]> =
  new Set(['global_realestates', 'global_segments']);
